import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

const Language = ({ color = 'icon.primary', ...props }) => (
  <IconBase viewBox='0 0 12 12' {...props}>
    <Path
      d='M6 12C2.7 12 0 9.3 0 6C0 2.7 2.7 0 6 0C9.3 0 12 2.7 12 6C12 9.3 9.3 12 6 12ZM4.75
      8.5C5.05 10.05 5.6 11 6 11C6.4 11 6.95 10.05 7.25 8.5H4.75ZM8.3 8.5C8.15 9.35 7.9
      10.15 7.6 10.75C8.75 10.35 9.75 9.55 10.35 8.5H8.3ZM1.65 8.5C2.25 9.55 3.25 10.35 4.4
      10.75C4.1 10.15 3.85 9.35 3.7 8.5H1.65ZM8.45 7.5H10.8C10.9 7.05 11 6.5 11 6C11 5.5 10.9 4.95
      10.75 4.5H8.4C8.5 5 8.5 5.5 8.5 6C8.5 6.5 8.5 7 8.45 7.5ZM4.6 7.5H7.45C7.5 7.05 7.55 6.55
      7.55 6C7.55 5.45 7.5 4.95 7.45 4.5H4.6C4.55 4.95 4.5 5.45 4.5 6C4.5 6.55 4.55 7.05
      4.6 7.5ZM1.25 7.5H3.6C3.55 7 3.55 6.5 3.55 6C3.55 5.5 3.55 5 3.6 4.5H1.25C1.1 4.95 1 5.5 1
      6C1 6.5 1.1 7.05 1.25 7.5ZM8.3 3.5H10.35C9.75 2.45 8.75 1.65 7.6 1.25C7.9 1.85 8.15
      2.65 8.3 3.5ZM4.75 3.5H7.3C7 1.95 6.45 1 6.05 1C5.65 1 5.05 1.95 4.75 3.5ZM1.65 3.5H3.7C3.85
      2.65 4.1 1.85 4.4 1.25C3.25 1.65 2.3 2.45 1.65 3.5Z'
      fill={color}
    />
  </IconBase>
)

Language.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  stroke: PropTypes.string,
}

export default Language
